export default __webpack_public_path__ + "static/media/challenge2.e1664cd7.jpg";